import React, { useEffect, useState } from "react";
import styles from "./scss/notecreate.module.scss";
import 'react-quill/dist/quill.snow.css';
import { URButton } from "../../../shared/widgets/button";
import { contactService } from "../../../base/contactService";
import TextArea from "antd/lib/input/TextArea";
import { Input } from "antd";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import { chats, chatwindowDetails, initialStateModel, LoginState } from "../../../models/model";
import { useSelector } from "react-redux";
import { ChatService } from "../../../base/chatService";

type CreateNoteState={
  title:any;
  description:any;
  errors:boolean;
  replace_id:any;
  sender:any;
  receiver:any
}
export default function CreateNote(props:any){
  let isContact= window.location.pathname=== "/contacts"?"contacts":"chats";
  const [state, setstate] = useState<CreateNoteState>({sender:"",receiver:"",title:"",description:"",errors:false,replace_id:""});
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
 let {  loginReducer } = allReducer;
  let { userdetails }: LoginState = loginReducer;
  let memberList = chatWindow?.chatWindowDetails?.team_members?.split(",");
  memberList = Array.isArray(memberList) && memberList.length > 0 ?
        memberList.map((data: any, index: any) => data.trim()) : [];
  useEffect(() => {
  
    if(props.isEdit){
      setstate({...state,sender:props.noteData.sender,receiver:props.noteData.receiver,title: props.noteData.summary, description:props.noteData.description,
        replace_id: props.noteData.replaceId ? props.noteData.replaceId :props.noteData.msgId?props.noteData.msgId:props.noteData.uid});
    }
    if(props.isKey === "notes"){
      setstate({ ...state, title: "", description: "", errors:false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isKey,props.noteData]);
  const onChangeInpout=(e:any)=>{
    setstate({...state,[e.target.name]: e.target.value,  errors:false});
  };

  const onSend=()=>{
    if(state.title.trim() === ""){
      setstate({ ...state, errors:true });
      return;
    } else {
      if(props.isEdit){
        contactService.editContactNote(state ,props.noteData.uid, isContact);
      } else  {
        contactService.createContactNote(state,isContact);
      }
      setstate({ ...state, title: "", description: "", errors:false });
    }
    
  };

  const onCancel=()=>{
    setstate({...state,title: "", description: "", errors:false});
    chatWindow.isMySpace ? chat_reducer.isWindowSlide && ChatService.rightSideToogle():  chatSideWindow(true,"notelist",{});
  };
  
  return (
    <>
      <div className={styles.rightsidebar}>
        <div className={styles.createNoteBody}>
          <div className={styles.inputfield}>
            <Input placeholder="Title" name="title" value={state.title} maxLength={40}
              className={`${styles.notesTitle} ${styles.inputarea}`} onChange={onChangeInpout}></Input>
          </div>
          {state.errors && <p className={styles.errorMsgs}>This note needs a title</p>}
          <div className={styles.inputfield}>
            <TextArea
              name="description"
              onChange={onChangeInpout}
              value={state.description}
              placeholder="Start writing or drag files"
              autoSize={{ minRows: 3 }}
              className={styles.notesDesc}
            />
          </div>
        </div>
        {/* {state.errors && <h3 className="errors">All fields are mandatory</h3>} */}
        <div className={styles.bottomlayers}>
          <URButton onClick={onCancel} name="Cancel" className="urButton buttonWhite"/>
          {(Array.isArray(memberList) &&  memberList?.includes(userdetails?.sip_login_id)) || chatWindow?.chatWindowDetails?.sip_login_id ? <URButton onClick={onSend} name={props.isEdit ? "Update" : "Create"} className="urButton buttonBlue marlftmin" /> : null}
        </div>
      </div>
    </>
  );
};